export const DOMAINS = [
  { name: "webuyhomesinmaricopa.com", value: 95000 },
  { name: "webuyhomesinmaricopa.org", value: 150000 },
  { name: "webuyhomesmaricopa.com", value: 100000 },
  { name: "webuymaricopa.com", value: 85000 },
  { name: "webuyphoenix.org", value: 240000 },
];

export const TOTAL_PORTFOLIO_VALUE = DOMAINS.reduce((s, d) => s + d.value, 0);

export const SERVICES = [
  {
    id: "software-development",
    title: "Software Development",
    short: "Custom web apps, SaaS platforms, dashboards, CRM systems and automation tools.",
    desc: "Custom web applications, SaaS platforms, dashboards, portals, CRM systems, automation tools, and business management software engineered for scale.",
    icon: "Code2",
  },
  {
    id: "website-design",
    title: "Website Design & Development",
    short: "Corporate websites, landing pages, SEO pages, and conversion-focused experiences.",
    desc: "Corporate websites, high-conversion landing pages, SEO-optimized content sites, e-commerce platforms, and web experiences built to convert.",
    icon: "Globe2",
  },
  {
    id: "business-consulting",
    title: "Business Consulting",
    short: "Technology planning, digital growth strategy, workflow automation and positioning.",
    desc: "Technology planning, digital growth strategy, workflow automation, operations consulting, and market positioning for ambitious operators.",
    icon: "Briefcase",
  },
  {
    id: "lead-generation",
    title: "Lead Generation Systems",
    short: "Funnels, automated follow-up, tracking dashboards, SEO and paid traffic systems.",
    desc: "Landing pages, CRM funnels, automated follow-up sequences, tracking dashboards, SEO campaigns, and paid traffic systems engineered for ROI.",
    icon: "Target",
  },
  {
    id: "domain-consulting",
    title: "Domain Portfolio Consulting",
    short: "Acquisition strategy, valuation, sales and premium domain positioning.",
    desc: "Domain acquisition strategy, domain sales, domain valuation support, premium domain positioning, and portfolio packaging for maximum value.",
    icon: "Network",
  },
  {
    id: "digital-assets",
    title: "Digital Asset Sales",
    short: "We consult, market and sell premium domains, web properties and lead-gen assets.",
    desc: "S&B Technologies consults, markets, and sells premium digital assets including domain names, branded web properties, and lead-generation opportunities.",
    icon: "Gem",
  },
];

export const WHY_DOMAINS = [
  { title: "Scarcity", desc: "Premium domains are finite digital real estate that can never be reproduced.", icon: "Diamond" },
  { title: "Search Authority", desc: "Exact-match domains carry inherent SEO weight and relevance signals.", icon: "Search" },
  { title: "Lead Generation", desc: "Geo-targeted domains capture high-intent traffic with zero ad spend.", icon: "TrendingUp" },
  { title: "Brand Dominance", desc: "Memorable, brandable URLs anchor authority across every channel.", icon: "Crown" },
  { title: "Long-Term Appreciation", desc: "Quality domains have historically appreciated as digital assets.", icon: "LineChart" },
  { title: "Market Control", desc: "Own the keyword. Own the category. Lock competitors out.", icon: "ShieldCheck" },
];

export const SOFTWARE_PRODUCTS = [
  { name: "Shop Advisors", category: "Advisory Suite", stage: "Concept" },
  { name: "Dealer Advisor", category: "Automotive Tech", stage: "Prototype" },
  { name: "Lead Advisor", category: "Lead Generation", stage: "Development" },
  { name: "Marketing Advisor", category: "Marketing Automation", stage: "Concept" },
  { name: "Web Advisor", category: "Web Strategy", stage: "Concept" },
  { name: "Contractor Advisor", category: "Construction Tech", stage: "Concept" },
  { name: "Tech Advisors", category: "Advisory Suite", stage: "Concept" },
  { name: "The Stipulator", category: "Workflow Automation", stage: "Prototype" },
  { name: "Tap In TV Network", category: "Media Platform", stage: "Portfolio" },
  { name: "Tap In Radio", category: "Audio Platform", stage: "Portfolio" },
  { name: "Locked In Forever", category: "Brand Platform", stage: "Portfolio" },
  { name: "YOLO.bid", category: "Marketplace", stage: "Portfolio" },
  { name: "Supreme Web Security", category: "Cybersecurity", stage: "Concept" },
];

export const INDUSTRIES = [
  { name: "Automotive", icon: "Car" },
  { name: "Real Estate", icon: "Home" },
  { name: "Construction", icon: "HardHat" },
  { name: "Entertainment", icon: "Clapperboard" },
  { name: "Media", icon: "Radio" },
  { name: "E-Commerce", icon: "ShoppingBag" },
  { name: "Professional Services", icon: "Briefcase" },
  { name: "Nonprofits", icon: "HeartHandshake" },
  { name: "Local Businesses", icon: "Store" },
  { name: "Startups", icon: "Rocket" },
];

export const PROJECT_TYPES = [
  "Software Development",
  "Website Development",
  "Domain Portfolio Inquiry",
  "Consulting",
  "Investor / Partnership Opportunity",
  "Digital Asset Purchase",
  "Other",
];

export const CONTACT = {
  email: "info@sbtechnologies.net",
  website: "www.sbtechnologies.com",
  company: "S&B Technologies",
  tagline: "Software Development | Digital Assets | Consulting | Domain Strategy",
};
